/* eslint-disable @angular-eslint/no-inputs-metadata-property */
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  ErrorsFormControlDirective,
  ErrorsFormControlDirectiveInputs,
} from '../directives/errors-form-control.directive';

@Component({
  imports: [],
  selector: 'ui-form-error',
  host: { class: 'block mt-1.25 text-(length:--font-size-body-s) text-(--text-status-error)' },
  templateUrl: './form-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: ErrorsFormControlDirective,
      inputs: ErrorsFormControlDirectiveInputs,
    },
  ],
})
export class FormErrorComponent {
  errors = inject(ErrorsFormControlDirective);
}
